module.exports = require("resolve-url-loader");